module.exports = __webpack_public_path__ + "img/muscle.4606c2d9.png";